<template>
  <div class="case">
    <div class="flex items-center">
      <div class="title">成分股情况</div>
      <div class="flex items-center" style="margin-left: auto; margin-right: 0">
        <div>
          <Download
            :dButtonsDownloads="dButtonsDownloads"
            :excel_info="excel_info"
            echartRefName="chaert1Ref" />
        </div>
        <div style="margin-left: 12px">
          <el-popover placement="top" width="160" v-model="save_popover">
            <div style="padding-bottom: 20px">是否保存上述操作</div>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                plain
                @click="save_popover = false"
                style="
                  background-color: transparent;
                  border-color: #616161;
                  color: var(--el-header-text-color);
                "
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="saveCfg()"
                style="
                  background-color: var(--primary-color);
                  border-color: var(--primary-color);
                  color: #333;
                "
                >确定</el-button
              >
            </div>
            <div slot="reference" class="btn-save">保存</div>
          </el-popover>
        </div>
      </div>
    </div>
    <div
      style="margin-top: 20px"
      :style="tabSummaryStyle"
      :data-a="(activeGroup || {}).name || 'all'">
      <el-table
        class="table1"
        :header-cell-style="tableStyle"
        :data="table_data"
        :height="thhhhh"
        @cell-click="fnClick"
        style="width: 100%"
        :show-summary="true"
        :summary-method="summaryMethod"
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        :cell-class-name="cellClassName">
        <el-table-column fixed width="55" type="index" />
        <el-table-column fixed width="110" label="代码" prop="reit_code" />
        <el-table-column fixed width="155" label="简称" prop="简称" />
        <el-table-column fixed width="90" label="大类" prop="大类" sortable />
        <el-table-column fixed width="95" label="细分" prop="细分" sortable />
        <el-table-column fixed width="120" label="权重" prop="quan_zhong" sortable>
          <template slot-scope="scope">
            <div class="flex items-center">
              <div v-if="queryOptions.cap_name !== 'custom'">{{ scope.row.quan_zhong }}%</div>
              <div
                class="ctx"
                @click="scope.row.quan_zhong_edit.edit = true"
                v-else-if="!scope.row.quan_zhong_edit.edit">
                {{ scope.row.quan_zhong }}%
                <i class="el-icon-edit"></i>
              </div>
              <div v-else class="dfhdfh">
                <el-input
                  type="number"
                  :key="scope.$index"
                  v-model="scope.row.quan_zhong_edit.value"
                  size="mini"
                  autofocus
                  maxlength="3"
                  style="width: 55px"
                  @keyup.enter.native="editBlur(scope)" />
              </div>
              <el-tooltip
                v-if="scope.row.quan_zhong_edit.error"
                class="item"
                effect="dark"
                :content="scope.row.quan_zhong_edit.error"
                placement="top">
                <i class="el-icon-warning" style="color: #f0a913; margin-left: 4px" />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="95" label="现价" prop="现价" sortable>
          <template slot-scope="scope">
            {{ scope.row.现价 | fix2 }}
          </template>
        </el-table-column>
        <el-table-column label="涨跌幅" width="130" prop="涨跌幅" sortable class-name="line-bar5">
          <template slot-scope="scope">
            <div class="flex items-center justify-center h-full">
              <div :style="{ width: '60%' }" class="flex items-center h-full">
                <div
                  class="color-bar9 left"
                  :class="{ 'opacity-0': scope.row.涨跌幅 >= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.涨跌幅), data_info.涨跌幅) * x10() || 0.01
                    ),
                  }"></div>
                <div class="line"></div>
                <div
                  class="color-bar9 right"
                  :class="{ 'opacity-0': scope.row.涨跌幅 <= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.涨跌幅), data_info.涨跌幅) * x10() || 0.01
                    ),
                  }"></div>
              </div>
              <div class="flex-1 text-left">
                {{ scope.row.涨跌幅 | pct }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="日均成交额" label="日均成交额(万元)" width="180" sortable>
          <template slot-scope="scope">
            <div class="flex items-center" style="margin-left: 20px">
              <div
                class="color-bar"
                :style="{
                  '--bar_color': '#5150bf',
                  '--w': calcPx(normalizeNew(scope.row.日均成交额, data_info.日均成交额) * x10()),
                }"></div>
              <div>{{ scope.row.日均成交额 | fix2 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="170" label="换手率(不含大宗)" prop="期间换手率" sortable>
          <template slot-scope="scope">
            {{ scope.row.期间换手率 | pct }}
          </template>
        </el-table-column>
        <el-table-column width="125" label="期间总回报" prop="期间总回报" sortable>
          <template slot-scope="scope">
            {{ scope.row.期间总回报 | pct }}
          </template>
        </el-table-column>
        <el-table-column width="110" label="价格收益" prop="期间价格回报" sortable>
          <template slot-scope="scope">
            {{ scope.row.期间价格回报 | pct }}
          </template>
        </el-table-column>
        <el-table-column width="110" label="分红收益" prop="期间分红回报" sortable>
          <template slot-scope="scope">
            {{ scope.row.期间分红回报 | pct }}
          </template>
        </el-table-column>
        <el-table-column
          width="165"
          label="与基准差额收益"
          prop="期间超额收益"
          sortable
          class-name="line-bar5">
          <template slot-scope="scope">
            <div class="flex items-center justify-center h-full">
              <div :style="{ width: '60%' }" class="flex items-center h-full">
                <div
                  class="color-bar9 left"
                  :class="{ 'opacity-0': scope.row.期间超额收益 >= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.期间超额收益), data_info.期间超额收益) *
                        x10() || 0.01
                    ),
                  }"></div>
                <div class="line"></div>
                <div
                  class="color-bar9 right"
                  :class="{ 'opacity-0': scope.row.期间超额收益 <= 0 }"
                  :style="{
                    '--bar_color': '#5150bf',
                    '--w': number2Pct(
                      normalizeNew(Math.abs(scope.row.期间超额收益), data_info.期间超额收益) *
                        x10() || 0.01
                    ),
                  }"></div>
              </div>
              <div class="flex-1 text-left">
                {{ scope.row.期间超额收益 | fix2 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="95" label="波动率" prop="期间年化波动率" sortable>
          <template slot-scope="scope">
            {{ scope.row.期间年化波动率 | pct }}
          </template>
        </el-table-column>
        <el-table-column width="110" label="最大回撤" prop="期间最大回撤" sortable>
          <template slot-scope="scope">
            {{ scope.row.期间最大回撤 | fix2 }}
          </template>
        </el-table-column>
        <el-table-column label="流通市值(亿元)" width="155" prop="流通市值" sortable>
          <template slot-scope="scope">
            <div class="flex items-center" v-if="scope.row.流通市值">
              <div
                class="color-bar"
                :style="{
                  '--bar_color': '#5ae8ed',
                  '--w': calcPx(normalizeNew(scope.row.流通市值, data_info.流通市值) * x10()),
                }"></div>
              <div>{{ scope.row.流通市值 | fix2 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="市值(亿元)" width="150" prop="总市值" sortable>
          <template slot-scope="scope">
            <div class="flex items-center" v-if="scope.row.总市值">
              <div
                class="color-bar"
                :style="{
                  '--bar_color': '#5ae8ed',
                  '--w': calcPx(normalizeNew(scope.row.总市值, data_info.总市值) * x10()),
                }"></div>
              <div>{{ scope.row.总市值 | fix2 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="160" label="期间平均分派率" prop="期间平均分派率" sortable>
          <template slot-scope="scope">
            <div class="flex items-center">
              <div
                v-if="scope.row.期间平均分派率"
                class="color-bar"
                :style="{
                  '--bar_color': '#feb144',
                  '--w': calcPx(scope.row.期间平均分派率 * x10()),
                }"></div>
              <div v-if="scope.row.期间平均分派率">{{ scope.row.期间平均分派率 | fix2_1 }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { fnReturnTableStyle } from '@/utils/util';
import { getDateInfo, normalizeNew, number2Pct, numberFix2 } from '@/utils';
import Download from '@/components/Basic/Download.vue';

function cssStringToObject(cssString) {
  const cssObject = {};
  // 移除字符串末尾可能存在的分号，并按分号分割
  const declarations = cssString.replace(/;$/, '').split(';');

  declarations.forEach((declaration) => {
    // 按冒号分割属性名和属性值
    const parts = declaration.split(':');
    if (parts.length === 2) {
      let propertyName = parts[0].trim();
      const propertyValue = parts[1].trim();

      // 将 kebab-case (如 border-bottom) 转换为 camelCase (如 borderBottom)
      propertyName = propertyName.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

      cssObject[propertyName] = propertyValue;
    }
  });

  return cssObject;
}
const calcPx = (n) => {
  const v = n * 70;
  return Math.min(v, 70) + 'px';
};
const getAll = (data, k, abs = false) => {
  const all = data.map((item) => {
    if (abs) return Math.abs(item[k]);
    return item[k];
  });
  let sum = 0;
  all.forEach((num) => (sum += num));
  return sum;
};
export default {
  props: {
    queryString: String,
    default_config: Object,
    activeGroup: [Object, undefined],
    quan_up_rate: Number,
    quan_down_rate: Number,
  },
  components: { Download },
  data() {
    return {
      thhhhh: 420,
      dButtonsDownloads: Object.freeze([
        /* {
          id: '241020',
          name: '下载图片',
        }, */
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      excel_info: Object.freeze({
        overviewName: '',
        excel_data: [],
        json_fields: {
          代码: 'reit_code',
          简称: '简称',
          大类: '大类',
          细分: '细分',
          现价: '现价',
          涨跌幅: '涨跌幅',
          成交额: '日均成交额',
          换手率: '期间换手率',
          期间总回报: '期间总回报',
          价格收益: '期间价格回报',
          分红收益: '期间分红回报',
          与基准差额收益: '期间超额收益',
          波动率: '期间年化波动率',
          最大回撤: '期间最大回撤',
          流通市值: '流通市值',
          市值: '总市值',
          期间平均分派率: '期间平均分派率',
        },
      }),
      loading: false,
      save_popover: false,
      table_data: [],
      data_info: {},
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tabSummaryStyle() {
      const val = this.$store.state.theme === 'dark';
      const style = fnReturnTableStyle(val);
      const { fontWeight, fontSize, color, borderTop, background } = cssStringToObject(style);
      return `--bfs:${fontSize};--tbt:${borderTop};--bfc:${color};--bfw:${fontWeight};--bbc:${background}`;
    },
    queryOptions() {
      const params = new URLSearchParams(this.queryString);
      const obj = {};
      for (const key of params.keys()) {
        const result = params.getAll(key);
        obj[key] = result.length > 1 ? result : result[0];
      }
      return obj;
    },
  },
  watch: {
    queryString: {
      handler: function () {
        this.loadData();
      },
      immediate: true,
    },
  },
  filters: {
    fix2_1(n) {
      if (n === '') return '';
      return numberFix2(n * 100) + '%';
    },
    pct(n) {
      if (n === '') return '';
      return number2Pct(n);
    },
    amt6(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 2);
    },
    fix2(n) {
      if (n === '') return '';
      return numberFix2(n, 2);
    },
    fix9(n) {
      if (n === '') return '';
      return numberFix2(n / 10000, 3);
    },
  },
  methods: {
    cellClassName({ row, column, rowIndex, columnIndex }) {
      const { label } = column;
      const is_hit = ['代码', '简称', '大类', '细分'].includes(label);
      if (is_hit) {
        return 'cursor-pointer';
      }
      return '';
    },
    fnClick(row, column, cell) {
      const { label } = column;
      const is_hit = ['代码', '简称', '大类', '细分'].includes(label);
      if (!is_hit) return;
      if (row.reit_code) {
        let arr = [row['简称'], row['reit_code']];
        this.$eventBus.$emit('skipPage', arr);
      }
    },
    x10() {
      if (this.activeGroup) {
        return 1;
      }
      return 10;
    },
    changeQueryString2() {
      const table_data = this.table_data;
      const weight_list = table_data.map((item) => item.quan_zhong / 100).join('&weight_list=');
      const qs = new URLSearchParams(this.queryString);
      qs.delete('codes');
      /*  if (!this.activeGroup) {
        this.$emit('changeQueryString2', `${qs.toString()}&codes=`);
      } else {
        const codes = table_data.map((item) => item.reit_code).join('&codes=');
        this.$emit(
          'changeQueryString2',
          `${qs.toString()}&codes=${codes}&weight_list=${weight_list}`
        );
      } */
      const codes = table_data.map((item) => item.reit_code).join('&codes=');
      this.$emit(
        'changeQueryString2',
        `${qs.toString()}&codes=${codes}&weight_list=${weight_list}`
      );
    },
    async defaultWeight() {
      if (this.queryOptions.cap_name === 'custom') {
        if (!this.activeGroup) {
          const cfg = this.default_config.quan_zhong_cfg || {};
          if (Object.keys(cfg).length) {
            return cfg;
          }
        } else {
          const quan_zhong_cfg = this.activeGroup.performance_config.quan_zhong_cfg || {};
          if (Object.keys(quan_zhong_cfg).length) return quan_zhong_cfg;
        }
      }
      this.loading = true;
      let weight_list = '';

      const { data } = await this.$https.get(
        `/api/v3_1/get_default_weight_list?${this.queryString}&weight_list=${weight_list}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      if (data.normal) {
        this.$message({
          message: data.normal,
          type: data.normal_bool ? 'success' : 'error',
        });
      }
      const cfg = data.data.reduce((p, c) => {
        p[c.reit_code] = (c['0'] * 100).toFixed(3) * 1;
        return p;
      }, {});
      return cfg;
    },
    async loadData() {
      if (this.activeGroup && this.activeGroup.reit_codes.length === 0) {
        this.$message.warning('该自选股组合没有添加个券');
        this.table_data = [];
        this.$emit('changeQueryString2', ``);
        return;
      }
      this.loading = true;
      const { data } = await this.$https.get(`/api/v3_1/constituent?${this.queryString}`);
      if (data.code !== 200) return this.$message.error(data.msg);
      const cfg = await this.defaultWeight();
      data.data.forEach((item) => {
        const v = cfg[item.reit_code] || item.quan_zhong || 0;
        item.quan_zhong = v;
        item.quan_zhong_edit = {
          value: v,
          edit: false,
          error: '',
        };
      });
      this.table_data = data.data;
      this.data_info = Object.freeze({
        涨跌幅: getAll(data.data, '涨跌幅', true),
        日均成交额: getAll(data.data, '日均成交额'),
        流通市值: getAll(data.data, '流通市值'),
        总市值: getAll(data.data, '总市值'),
        期间超额收益: getAll(data.data, '期间超额收益', true),
      });
      this.loading = false;
      this.changeQueryString2();
      const overviewName = this.activeGroup ? `${this.activeGroup.name}表现` : '全部REITs表现';
      this.excel_info = Object.freeze({
        overviewName,
        excel_data: data.data,
        json_fields: this.excel_info.json_fields,
      });
      setTimeout(() => {
        if (this.thhhhh === 420) {
          this.thhhhh += 1;
        } else {
          this.thhhhh -= 1;
        }
      }, 0);
    },
    saveCfg(flag) {
      this.save_popover = false;
      const v = this.table_data.reduce((prev, cur) => prev + cur.quan_zhong, 0);
      if (v.toFixed(2) * 1 != 100) {
        this.$message.warning('权重总和必须为100%');
        return;
      }
      if (this.queryOptions.cap_name === 'custom' || flag) {
        const cfg = this.table_data.reduce((p, c) => {
          p[c.reit_code] = c.quan_zhong;
          return p;
        }, {});
        this.$emit('saveCfg', cfg, flag);
      } else {
        this.$emit('saveCfg', {}, flag);
      }
    },
    summaryMethod({ columns, data }) {
      return columns.map(({ label }, index) => {
        if (index === 0) {
          return '汇总';
        }
        if (label === '权重') {
          const t = data.reduce((prev, cur) => {
            return prev + (cur.quan_zhong || 0);
          }, 0);
          let tooltip = '';
          if (t.toFixed(2) > 100) {
            tooltip = (
              <el-tooltip class="item" effect="dark" content="权重超出100%" placement="top">
                <i class="el-icon-warning" style="color: #f0a913;margin-left:4px" />
              </el-tooltip>
            );
          }
          if (t.toFixed(2) < 100) {
            tooltip = (
              <el-tooltip class="item" effect="dark" content="权重不足100%" placement="top">
                <i class="el-icon-warning" style="color: #f0a913;margin-left:4px" />
              </el-tooltip>
            );
          }
          const numberFix2N = (n, size = 2) => {
            const formatter = new Intl.NumberFormat('en-US', {
              // 使用 'en-US' 或任何不使用分组的 locale
              minimumFractionDigits: size,
              maximumFractionDigits: size,
              useGrouping: true, // 不使用分组
              roundingMode: 'trunc', //  直接截断，等同于floor
            });

            return formatter.format(n);
          };
          const t2 = numberFix2N(t);
          return (
            <div>
              <span>{t2}%</span>
              {tooltip}
            </div>
          );
        }
        return '';
      });
    },
    calcPx,
    normalizeNew,
    number2Pct,
    /*     handleInput(scope) {
      const { $index: index } = scope;
      const item = this.table_data[index];
      return (event) => {
        if (event === '') {
          item.quan_zhong = 0;
        } else {
          let v = parseInt((event.match(/\d/g) || []).join(''));
          if (v > 100) v = 100;
          item.quan_zhong = v;
        }
      };
    }, */
    editBlur(scope) {
      const { $index: index } = scope;
      const item = this.table_data[index];
      const v = item.quan_zhong_edit.value * 1;
      const isChange = item.quan_zhong !== v;
      let error = '';
      if (item.quan_zhong > this.quan_up_rate) error = '权重超出上限';
      if (item.quan_zhong < this.quan_down_rate) error = '权重超出下限';

      this.$set(this.table_data, index, {
        ...item,
        quan_zhong: v,
        quan_zhong_edit: {
          value: item.quan_zhong_edit.value,
          edit: false,
          error,
        },
      });
      const hasError = this.table_data.some((item) => item.quan_zhong_edit.error);
      const rv = this.table_data.reduce((prev, cur) => prev + cur.quan_zhong, 0);
      const eq100 = rv.toFixed(2) * 1 === 100;
      console.log(eq100);
      if (isChange && !hasError && eq100) {
        this.changeQueryString2();
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/.cursor-pointer {
  cursor: pointer;
}
/deep/.el-table__fixed::before {
  background-color: transparent;
}
/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  color: var(--bfc);
  background-color: var(--bbc);
  border-color: transparent;
}
/* /deep/.el-table .el-table__cell {
  padding: 0 !important;
}
/deep/.el-table__body .el-table__row .el-table__cell {
  height: calc(var(--ROOTFONTFIZE) * (30 / 144)) !important;
}
/deep/.el-table__footer-wrapper tbody td.el-table__cell {
  font-weight: 500 !important;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144)) !important;
} */

/* 针对Chrome, Safari, Edge, Opera */
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 针对Firefox */
/deep/input[type='number'] {
  -moz-appearance: textfield;
}

.flex {
  display: flex;
}
.items-center {
  align-items: center;
}

.case {
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  color: var(--el-header-text-color);
  /deep/.el-table__fixed {
    // pointer-events: none;
  }
  .title {
    font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  }
  .btn-save {
    cursor: pointer;
    padding: 6px 16px;
    color: #333;
    border-radius: 2px;
    font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
    background-color: var(--primary-color);
  }
  /deep/.ctx {
    display: flex;
    align-items: center;
    .el-icon-edit {
      display: none;
    }
    &:hover {
      color: var(--primary-color);
      .el-icon-edit {
        display: block;
        margin-left: 10px;
      }
    }
  }
  /deep/.dfhdfh {
    .el-input {
      margin-left: 0;
      input {
        padding: 0 5px;
        color: var(--el-header-text-color);
        border-color: var(--primary-color);
        background-color: var(--Btn-bgc);
      }
    }
  }
}

/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  font-size: var(--bfs);
  border-top: var(--tbt);
  color: var(--bfc);
  font-weight: var(--bfw);
  background-color: var(--bbc);
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.h-full {
  height: 100%;
}
/deep/.flex {
  display: flex;
}
/deep/.items-center {
  align-items: center;
}
/deep/.space-between {
  justify-content: space-between;
}
/deep/.justify-center {
  justify-content: center;
}
/deep/.color-bar {
  width: var(--w);
  min-width: 1px;
  height: 16px;
  margin-right: 10px;
  background-color: var(--bar_color);
}

/deep/.color-box {
  padding: 0 !important;
}
/deep/.color-box .cell {
  height: 100%;
  width: 100%;
  padding: 0;
}
/deep/.color-box .cell > div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  color: #fff;
  background-color: var(--box-color);
}
/deep/.line-bar5 {
  padding: 0 !important;
}
/deep/.line-bar5 .cell {
  height: 100%;
  width: 100%;
  padding: 0;
}
/deep/.flex-1 {
  flex: 1;
}
.opacity-0 {
  opacity: 0;
}
/deep/.line {
  flex: none;
  width: 1px;
  height: 100%;
  border-left: 1px dashed #fff;
}
/deep/.text-left {
  text-align: left;
}

/deep/.color-bar9 {
  width: 50%;
  height: 16px;
  &.left {
    background: linear-gradient(to left, var(--bar_color) var(--w), rgba(0, 0, 0, 0) 0%);
  }
  &.right {
    background: linear-gradient(to right, var(--bar_color) var(--w), rgba(0, 0, 0, 0) 0%);
  }
}
/deep/.el-table {
  padding-bottom: 0 !important;
}
/deep/ .el-table table {
  border: none !important;
}
</style>
